import React, {createContext} from 'react';

const userContext = React.createContext();

export default userContext;